import React from 'react';
import Redirect from '../../../routes/Redirect';


class Home extends React.Component {
    client = JSON.parse(localStorage.getItem('login'))
    redirectTo = this.client.customer.name === 'FACCHINI' ? 'journey/dashboard-journey' : 'dashboard/weekly-follow-up'
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            redirect: false
        }
    }


    componentDidMount = () => {
        setTimeout(() => {
            this.setState({ redirect: true })

        }, 50);
    }
    render() {
        console.log('local', this.client.customer)
        
        return <Redirect to={this.redirectTo} redirect={this.state.redirect} />

    }
}
export default Home